module.exports = __webpack_public_path__ + "img/esy.7c346911.jpg";